<div class="hb-fieldset">
  <div class="hb-legend">
    @if (tittel()) {
      <div class="hb-legend-tekst" aria-hidden="true">
        {{ tittel() }}
      </div>
    }
  </div>
</div>

@if (list.length > 0) {
  <fieldset class="hb-felt">
    @if (tittel()) {
      <legend class="hb-screenreader-only">{{ tittel() }}</legend>
    }
    <ul class="hb-feltliste" [ngClass]="type() === 'buttons' ? 'hb-buttongroup' : ''">
      @for (item of list; track item.qText) {
        <li>
          <input
            [name]="id() + '-' + item.qText"
            [id]="id() + '-' + item.qText"
            [class]="'state-' + item.qState.toLowerCase()"
            [ngClass]="type() === 'checkbox' ? 'hb-checkbox' : 'hb-radiobutton'"
            [type]="type() === 'checkbox' ? 'checkbox' : 'radio'"
            value="{{ item.qText }}"
            [checked]="isSelected.includes(item.qState)"
            [disabled]="multiselect() ? false : isDisabled.includes(item.qState)"
          />
          <div class="hb-label">
            <label [for]="id() + '-' + item.qText" [class]="type() !== 'buttons' ? 'hb-label-tekst' : 'hb-button hb-button--standard'" (click)="select(id(), item, null)">{{
              item.qText
            }}</label>
          </div>
          @if (subId() && childrenList && isSelected.includes(item.qState)) {
            <ul style="padding-left: 1em" class="hb-feltliste qlik-underliste" [ngClass]="type() === 'buttons' ? 'hb-buttongroup' : ''">
              @for (subitem of childrenList[item.qText]; track subitem.qText) {
                <li>
                  <input
                    [name]="subId() + '-' + subitem.qText"
                    [id]="subId() + '-' + subitem.qText.replace(' ', '-')"
                    [class]="'state-' + subitem.qState.toLowerCase()"
                    [ngClass]="type() === 'checkbox' ? 'hb-checkbox' : 'hb-radiobutton'"
                    [type]="type() === 'checkbox' ? 'checkbox' : 'radio'"
                    [value]="multiselect() ? item.qElemNumber : subitem.qText"
                    [checked]="allChildrenSelected[item.qText] === true ? false : isSelected.includes(subitem.qState)"
                    [disabled]="multiselect() ? false : isDisabled.includes(subitem.qState)"
                  />
                  <div class="hb-label">
                    <label
                      [for]="subId() + '-' + subitem.qText.replace(' ', '-')"
                      [class]="type() !== 'buttons' ? 'hb-label-tekst' : 'hb-button hb-button--standard'"
                      (click)="select(subId(), subitem, item)"
                      >{{ subitem.qText }}</label
                    >
                  </div>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </fieldset>
}
